import { render, staticRenderFns } from "./GlsParcelShop.vue?vue&type=template&id=8ae957ee&scoped=true&"
import script from "./GlsParcelShop.vue?vue&type=script&lang=js&"
export * from "./GlsParcelShop.vue?vue&type=script&lang=js&"
import style0 from "./GlsParcelShop.vue?vue&type=style&index=0&id=8ae957ee&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae957ee",
  null
  
)

export default component.exports